/**
 * @since 2026-04-18
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { Notifications } from "components/Shared/Notifications";
import App from "components/App";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Notifications>
      <App />
    </Notifications>
  </React.StrictMode>
);
